import { globalHistory } from '@reach/router'
import { motion } from 'framer-motion'
import { Link } from 'gatsby'
import React, { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'

import * as constants from '../consts/index'
import useAnimatedContainerToggler from '../helpers/useAnimatedContainerToggler'
import useWindowDimensions from '../helpers/useWindowDimensions'
import { ReactComponent as CloseIcon } from '../images/close.svg'
import { ReactComponent as SearchIcon } from '../../node_modules/feather-icons/dist/icons/search.svg'
import { ReactComponent as FilterIcon } from '../images/filter-results-button.svg'
import getCategoryList, { nth_occurrence } from '../helpers/getCategoryList'

const CategoryLabelTitle = tw.h1`tracking-wider text-lg text-gray-500 mb-4 uppercase`

const CategoryTitleContainer = tw.div`m-2`
const CategoryTitle = tw.h2`border border-gray-900 rounded-md px-4 py-2 text-gray-900 text-lg tracking-wide cursor-pointer hover:text-green-500 hover:border-green-500 leading-8 inline-block`
const CategoryTitleActive = styled(CategoryTitle)`
  ${tw`text-green-500 border-2 border-transparent border-green-500 font-bold`}
`

const InternalHeader = tw.div`
  flex justify-between items-center max-w-screen-xl mx-auto pt-8
`

const MobileNavLinksContainer = tw.nav`flex flex-1 items-center justify-between z-auto`

const MobileNavLinks = motion.custom(styled.div`
  ${tw`h-screen lg:hidden z-60 fixed top-0 inset-x-0 px-8 bg-gray-900  bg-opacity-50 overflow-y-scroll`}
`)

const NavLinks = tw.div`flex flex-col items-center justify-center mt-8`
// ${tw`h-screen lg:hidden z-10 fixed top-0 inset-x-0 mx-4 my-6 p-8 border text-center rounded-lg text-gray-200 bg-gray-900`}

const NavToggle = tw.div`transition duration-300`

// eslint-disable-next-line no-unused-vars
function MobileCategoryComponent({ categoryList, setSearchText }) {
  const [searchInput, setSearchInput] = useState('')

  const {
    showContainerLinks,
    animation,
    toggleContainer,
  } = useAnimatedContainerToggler()

  const { width } = useWindowDimensions() || {}

  if (width >= constants.mdWidth) {
    if (showContainerLinks) {
      toggleContainer()
      setSearchInput('');
    }
  }

  const currentPath = globalHistory.location.pathname.replace('%20', ' ')

  const node = useRef()

  useEffect(() => {
    // add when mounted
    if (showContainerLinks) {
      document.addEventListener('mousedown', handleClick)
    }
    // return function to be called when unmounted
    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [showContainerLinks])

  useEffect(() => {
    if (setSearchText) {
      const timeOutId = setTimeout(() => setSearchText(searchInput), 500)
      return () => clearTimeout(timeOutId)
    }
  }, [searchInput])

  const handleClick = (e) => {
    if (node.current.contains(e.target)) {
      // inside click
      return
    }
    // outside click
    toggleContainer()
  }

  let tempListOfCategories = getCategoryList(categoryList)
  var tempListOfCategories2 = tempListOfCategories

  const searchForItem = () => {
    toggleContainer()
  }

  return (
    <InternalHeader>
      <MobileNavLinksContainer
        css={collapseBreakpointCss.mobileNavLinksContainer}
      >
        <MobileNavLinks
          initial={{ x: '150%', display: 'none' }}
          animate={animation}
          css={collapseBreakpointCss.mobileNavLinks}
        >
          <NavLinks>
            <div
              ref={node}
              className={
                'text-left bg-white w-full h-auto rounded-lg shadow-lg p-12 relative'
              }
            >
              <span
                className={'absolute right-5 top-5 text-green-300'}
                onClick={toggleContainer}
              >
                <CloseIcon
                  tw={'w-3 cursor-pointer text-gray-700 fill-current'}
                />
              </span>
              <CategoryLabelTitle>Filter</CategoryLabelTitle>
              <div className="mb-4">
                <label className="relative text-gray-400 focus-within:text-gray-600 block">
                  <input
                    type="search"
                    name="email"
                    value={searchInput}
                    onChange={(event) => setSearchInput(event.target.value)}
                    id="email"
                    placeholder="Search..."
                    className="form-input rounded bg-gray-100 border border-gray-200 py-2 px-2 bg-gray-100 text-gray-700 appearance-none w-full block pr-8 focus:outline-none focus:border-green-500 focus:bg-white"
                  ></input>
                  <SearchIcon
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={searchForItem}
                  />
                </label>
              </div>
              <CategoryLabelTitle>Categories</CategoryLabelTitle>
              <div className={'flex flex-row w-full flex-wrap'}>
                {tempListOfCategories2.map(({ node }) => {
                  return (
                    <CategoryTitleContainer key={node.internalComponentName}>
                      {node.path === currentPath ||
                      node.path ===
                        currentPath.substring(
                          0,
                          nth_occurrence(currentPath, '/', 3)
                        ) ? (
                        <CategoryTitleActive
                          as={Link}
                          key={node.internalComponentName}
                          to={node.path}
                        >
                          {node.internalComponentName}
                        </CategoryTitleActive>
                      ) : (
                        <CategoryTitle
                          as={Link}
                          onClick={toggleContainer}
                          key={node.internalComponentName}
                          to={node.path}
                        >
                          {node.internalComponentName}
                        </CategoryTitle>
                      )}
                    </CategoryTitleContainer>
                  )
                })}
              </div>
            </div>
          </NavLinks>
        </MobileNavLinks>
        <button
          className={
            'flex items-center justify-center w-full mx-6 py-3 border-2 border-gray-700 rounded-lg focus:outline-none md:hidden mt-8'
          }
          onClick={toggleContainer}
        >
          <FilterIcon className={'w-5 text-gray-700 fill-current mr-2'} />
          <NavToggle className={showContainerLinks ? 'open' : 'closed'}>
            Filter
          </NavToggle>
        </button>
      </MobileNavLinksContainer>
    </InternalHeader>
  )
}

const collapseBreakPointCssMap = {
  sm: {
    mobileNavLinks: tw`sm:hidden`,
    desktopNavLinks: tw`sm:flex`,
    mobileNavLinksContainer: tw`sm:hidden`,
  },
  md: {
    mobileNavLinks: tw`md:hidden`,
    desktopNavLinks: tw`md:flex`,
    mobileNavLinksContainer: tw`md:hidden`,
  },
  lg: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`,
  },
  xl: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`,
  },
}
const collapseBreakpointCss = collapseBreakPointCssMap['lg']

export default MobileCategoryComponent
